<script>
import SearchResults from "../search/SearchResults.vue"

export default {
  props: ['location', 'searchLocation'],
  components: {
    SearchResults
  },
  data: function () {
    return {
      collections: {
        art_types: [],
        artists_in_location: [],
        other_artists: [],
        specialities: [],
        currentUrlLocation: this.searchLocation
      },
      currentSearchLocation: this.searchLocation,
      cities: [],
      query: ''
    }
  },
  methods:{
    find(event){
      this.query = event.target.value || ''
      const new_query = (event.target.value || '').trim()

      if (new_query) {
        const params = {
          location: this.location,
          query: new_query
        }

        this.$axios.get('search/suggestions', {params: params})
          .then(response => {
            let findCity = this.query.length == 1 ? true : false

            if(findCity && window.location.pathname.includes("/discover")) {
              let filterCity = ''
              let location = localStorage.getItem('location_country')
              this.$axios.get('/cities', {
                params: {
                  country_code: location,
                }
              })
              .then(cityResponse => {
                this.cities = cityResponse.data
                const city = this.cities.find(city => city.name.toLowerCase() === this.searchLocation);
                filterCity = city ? this.generateShortForm(city.name).toLowerCase() : '';
                this.collections = response.data
                this.collections.currentUrlLocation = filterCity ? filterCity : localStorage.getItem('short_form', '');
                this.currentSearchLocation = this.collections.currentUrlLocation
                findCity = false
              })
            } else {
              this.collections = response.data
              this.collections.currentUrlLocation = this.currentSearchLocation
            }
          })
      }
    },
    generateShortForm(name) {
      return name.replace(/\s+/g, '')
    },
    closeSearch(){
      this.query = ''
      setTimeout(() => {
        this.searchModal = false
      }, 100)
    }
  },
  beforeDestroy(){
    document.querySelector('body').style = null
  }

}
</script>

<template>
  <div class="discover-filter mt-4 border-bottom-0 position-relative">
    <input
    :value="query"
     class="discover-filter-mobile__inputs"
     :placeholder="'Search'"
     style="background-color: #eff4fa;"
     type="text"
     @input="find"
    />

    <div
      class="discover-filter-image"
      @click="$emit('openFilters')">
    </div>

    <search-results
      :collections="collections"
      :query="query"
    />
  </div>
</template>
